import { Text } from '@chakra-ui/react'
import { useCallback } from 'react'
import { useBoolean } from 'react-use'
import { Button } from 'uikit'
import {
  Container,
  FilterHeader,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { Modal } from 'uikit'
import { ReportsList } from './ReportsList/ReportsList'
import { ReportValues, ReportsMutate } from './ReportsMutate'
import useFetchReportsList from './hooks/useFetchReportsList'
import { useSendPaymentsRegistry } from './hooks/useSendPaymentsRegistry'

export const Reports = () => {
  const [createFormIsOpen, setOpenCreate] = useBoolean(false)
  const { mutate: sendRegistry, isPending: formIsLoading } = useSendPaymentsRegistry()
  const { lastPage, list, isLoading: listIsLoading, hasMore, fetchNextPage } = useFetchReportsList()

  const onSubmitHandle = useCallback((values: ReportValues) => {
    sendRegistry(values, {
      onSuccess: () => {
        setOpenCreate(false)
      },
    })
  }, [])

  return (
    <Container>
      <SnippetsContainer indentTop={70}>
        <SnippetsContainerMain>
          <ReportsList
            data={list}
            hasMore={hasMore}
            isLoading={listIsLoading}
            onNext={fetchNextPage}
          />
        </SnippetsContainerMain>
        <SnippetsContainerRightAside>
          <FilterHeader>
            <Button width="100%" onClick={() => setOpenCreate(true)} colorPalette="orange">
              Отправить заявку
            </Button>
            <Text
              fontSize="0.8rem"
              color="gray.300"
              mt={2}
              textAlign="center"
            >{`Найдено: ${lastPage?.totalElements}`}</Text>
          </FilterHeader>
        </SnippetsContainerRightAside>
      </SnippetsContainer>
      <Modal
        isOpen={createFormIsOpen}
        onClose={() => setOpenCreate(false)}
        title="Отправить заявку"
      >
        <ReportsMutate onSubmit={onSubmitHandle} isLoading={formIsLoading} />
      </Modal>
    </Container>
  )
}
